module.exports = __webpack_public_path__ + "media/src/public/fonts/Gals-Regular-f90782c7dc5c9fd8d629e462b15f1218.ttf";